<template>
  <div class="flow-flex-center jFlow">
    <div class="wrap">

      <div class="bullet-center fl-right">
        <router-link
          to="/flows">
          <i class="fa fa-times"/>
        </router-link>
      </div>

      <div class="bullet-center">
        <h2>Create Flow By Division</h2>
      </div>

      <jFormFlowType2
        ref="formFlowType2"
        mode="create"
        @getData="getData"/>

      <div class="float-to-right m__t--50">
        <b-button
          class="btn blue"
          @click="createFlow">
          Create
        </b-button>
      </div>

    </div>
  </div>
</template>

<script>
import jFormFlowType2 from '@/components/form/flow/jFormFlowType2';
import { jMixModelCreateFlowType2 } from '@/mixins/model/flow/jMixModelCreateFlowType2';

export default {
  components: {
    jFormFlowType2,
  },
  mixins: [
    jMixModelCreateFlowType2,
  ],
  data() {
    return {
      flow: null,
    };
  },
  methods: {
    getData(data) {
      this.flow = data;
    },

    createFlow() {
      this.$refs.formFlowType2.validateForm();
      if (this.flow !== null) {
        this.sendData();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/create/jFlowCreateType2.vue